import queryClient from 'api/queryClient'

export type EntityCacheSubscriptionKind = 'answer' | 'quest' | 'userNorm'

const listenersByEntity = new Map<string, Set<() => void>>()

const subscriptionKey = (kind: EntityCacheSubscriptionKind, id: string | number) =>
    `${kind}:${String(id)}`

queryClient.getQueryCache().subscribe(event => {
    if (event.type !== 'added' && event.type !== 'removed' && event.type !== 'updated') return

    const queryKey = event?.query?.queryKey
    if (!Array.isArray(queryKey) || queryKey.length !== 2) return

    const kind = queryKey[0]
    const id = queryKey[1]
    if (kind !== 'answer' && kind !== 'quest' && kind !== 'userNorm') return
    if (id === null || id === undefined) return

    listenersByEntity.get(subscriptionKey(kind, String(id)))?.forEach(listener => listener())
})

export function subscribeToCachedEntity(
    kind: EntityCacheSubscriptionKind,
    id: string | number | null | undefined,
    listener: () => void,
) {
    if (id === null || id === undefined) return () => {}

    const key = subscriptionKey(kind, id)
    let listeners = listenersByEntity.get(key)
    if (!listeners) {
        listeners = new Set()
        listenersByEntity.set(key, listeners)
    }
    listeners.add(listener)

    return () => {
        listeners?.delete(listener)
        if (listeners?.size === 0) listenersByEntity.delete(key)
    }
}

export function getSubscribedEntityIds(kind: EntityCacheSubscriptionKind) {
    const prefix = `${kind}:`
    return Array.from(listenersByEntity.keys())
        .filter(key => key.startsWith(prefix))
        .map(key => key.slice(prefix.length))
}

export function isCachedEntitySubscribed(kind: EntityCacheSubscriptionKind, id: string | number) {
    return listenersByEntity.has(subscriptionKey(kind, id))
}
